import PenlySeo from './PenlySeo';

export default PenlySeo;
